<template>
  <b-card :title="`${title} Summary`">

    <!-- Format: General -->
    <general-summary
      v-if="['General', 'Keyworker'].includes(summary.summary_format)"
      :id="summary.id"
      :summary="summary.summary"
    />

    <!-- Format: JSON -->
    <json-summary
      v-if="summary.summary_format === 'JSON'"
      :summary="summary.summary"
    />

    <!-- Format: QuestionAndAnswer -->
    <q-and-a-summary
      v-if="summary.summary_format === 'QuestionAndAnswer'"
      :summary="summary.summary"
    />

    <!-- Format: Markdown -->
    <markdown-summary
      v-if="summary.summary_format === 'Markdown'"
      :summary="summary.summary"
    />
  </b-card>
</template>

<script>
import GeneralSummary from '@/views/auditTrail/Summaries/GeneralSummary.vue';
import JsonSummary from '@/views/auditTrail/Summaries/JsonSummary.vue';
import QAndASummary from '@/views/auditTrail/Summaries/QAndASummary.vue';
import MarkdownSummary from '@/views/auditTrail/Summaries/MarkdownSummary.vue';

export default {
  name: 'scribe-summary',
  components: { MarkdownSummary, QAndASummary, JsonSummary, GeneralSummary },
  props: {
    summary: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      const title = this.$options.filters.capEachWord(this.$options.filters.splitCamelCase(this.summary.summary_type))
      if (title === 'Assurance Alliance Action Plan') {
        return 'CSAP'
      }
      return title
    },
  },
}
</script>
